import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { corefetch, corepost } from "../../Util/axios_core_helper";

const initialState = {
  refresh: 0,
  flag: 0,
  flagrefresh: false,
  aboutSectionList: [],
  aboutSectionLoaded: false,
};

export const SaveWelcomeSection = createAsyncThunk(
  "SaveWelcomeSection",
  async (obj) => {
    return await corepost(
      `WelcomeSection/InsertUpdateWelcomeSection`,
      obj,
      true,
      true,
      false,
      false
    );
  }
);

export const GetAboutUsSectionList = createAsyncThunk(
  "GetAboutUsSectionList",
  async (obj) => {
    return await corefetch("WelcomeSection/GetAboutUsSectionList");
  }
);
const WelcomeSectionSlice = createSlice({
  name: "WelcomeSection",
  initialState: initialState,
  //   reducers: {
  //     onRefresh: (state) => {
  //       state.refresh = state.refresh + 1;
  //     },
  //   },
  extraReducers: (builder) => {
    builder.addCase(SaveWelcomeSection.pending, (state) => {
      state.flagrefresh = false;
    });

    builder.addCase(SaveWelcomeSection.fulfilled, (state, data) => {
      state.flag = data.payload;
      state.flagrefresh = true;
    });

    builder.addCase(SaveWelcomeSection.rejected, (state) => {
      state.flag = null;
      state.flagrefresh = true;
    });

    builder.addCase(GetAboutUsSectionList.pending, (state) => {
      state.aboutSectionLoaded = false;
    });

    builder.addCase(GetAboutUsSectionList.fulfilled, (state, data) => {
      state.aboutSectionList = data.payload;
      state.aboutSectionLoaded = true;
    });

    builder.addCase(GetAboutUsSectionList.rejected, (state) => {
      state.aboutSectionList = [];
      state.aboutSectionLoaded = true;
    });
  },
});

export default WelcomeSectionSlice.reducer;
